import React from "react";

const SentimentResult = ({ title, sentimentResult }) => {
  return (
    <div>
      <h3 style={{marginBottom:"0px"}} >{title}</h3>

      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <p>
            Positive Words:{" "}
            <span style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem" }}>
              {sentimentResult.positive.length > 0 ? (
                sentimentResult.positive.map((word, index) => (
                  <span key={index}>
                    {word}
                    {index !== sentimentResult.positive.length - 1 ? "," : ""}
                  </span>
                ))
              ) : (
                <span> None </span>
              )}
            </span>
          </p>
        </div>

        <div>
          <p>
            Negative Words:{" "}
            <span style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem" }}>
              {sentimentResult.negative.length > 0 ? (
                sentimentResult.negative.map((word, index) => (
                  <span key={index}>
                    {word}{" "}
                    {index !== sentimentResult.negative.length - 1 ? "," : ""}
                  </span>
                ))
              ) : (
                <span> None </span>
              )}
            </span>
          </p>
        </div>
      </div>

      <p>Overall Sentiment Score: {sentimentResult.score}</p>
      {sentimentResult.score > 0 ? (
        <p>The sentiment is positive.</p>
      ) : sentimentResult.score < 0 ? (
        <p>The sentiment is negative.</p>
      ) : (
        <p>The sentiment is neutral.</p>
      )}
    </div>
  );
};

export default SentimentResult;
